import React, { Component } from 'react';

const Form = props => (
  <div className="container-account-form-setting">
    <div>
      <textarea
        id="setting"
        defaultValue={
          props.datos
            ? JSON.stringify(props.datos.value ? JSON.parse(props.datos.value) : {}, undefined, 4)
            : JSON.stringify({}, undefined, 4)
        }
      />
    </div>
    <div className="right">
      <button onClick={props.handleSetting}>
        <i className="fas fa-save" />{' '}
        {props.language ? props.language.account.accountUser.accountSettings.save : ''}
      </button>
    </div>
  </div>
);

export default Form;



// WEBPACK FOOTER //
// ./source/client/components/account_setting/form.jsx